<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p45"><span><a href="#/Contents#rp45">WINTER GAZPACHO</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>This hot version of gazpacho brings vegetable-garden flavors and a bright assortment of garnishes to the winter dinner table.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 cup each: water, packed spinach</span></p>
<p class="hang"><span>½ cup each: chopped carrots, celery, green bell pepper</span></p>
<p class="hang"><span>4 cups reduced-sodium tomato juice, divided</span></p>
<p class="hang"><span>2 teaspoons low-sodium Worcestershire sauce</span></p>
<p class="hang"><span>1 teaspoon beef bouillon crystals</span></p>
<p class="hang"><span>¼ teaspoon dried tarragon leaves</span></p>
<p class="hang"><span>Salt and cayenne pepper, to taste</span></p>
<p class="hang"><span>1 each: chopped small onion, hard-cooked egg, cubed small avocado</span></p>
<p class="hang"><span>1½ cups Garlic or Herb Croutons (½ recipe) (see <span href="#/Chapter131#p849b" title="Link target outside of Sample">p. 637</span>, <span href="#/Chapter131#p849a" title="Link target outside of Sample">636</span>)</span></p>
<p class="normalt"><span><b>1.</b> Heat water, spinach, carrots, celery, and bell pepper to boiling in large saucepan. Heat to boiling; reduce heat and simmer, covered, until carrots are tender, about 8 minutes. Process vegetable mixture, 2 cups tomato juice, Worcestershire sauce, bouillon crystals, and tarragon in food processor or blender until smooth; return to saucepan. Add remaining 2 cups tomato juice and cook over medium heat until hot, about 5 minutes. Season to taste with salt and cayenne pepper. Serve in shallow bowls; sprinkle with chopped onion, egg, avocado, and Garlic Croutons.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 115</span></p>
<p class="per1"><span>% calories from fat: 27</span></p>
<p class="per1"><span>Protein (g): 4.2</span></p>
<p class="per1"><span>Carbohydrate (g): 18.3</span></p>
<p class="per1"><span>Fat (g): 3.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.7</span></p>
<p class="per1"><span>Cholesterol (mg): 35.3</span></p>
<p class="per1"><span>Sodium (mg): 221</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0226.vue?8c91ed18